import React from "react";

function Legislacion() {
    return (
        <div>
            <h3>
                Legislación Aplicable:
            </h3>
            <p>
                Legislación Aplicable Las condiciones presentes se regirán por la legislación
                española vigente.
            </p>
        </div>
    )
}

export default Legislacion;